module.exports = __webpack_public_path__ + "img/error.c6394578.png";